var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _circle, _circle2, _rect, _rect2, _path41, _path42, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountL2Tip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 252,
    height: 151,
    viewBox: "0 0 252 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.8109 65.1548L70.3039 56.3087L52.7969 65.1548L70.3039 74.2894L87.8109 65.1548Z",
    fill: "#FF8D6D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3457 65.1957L70.2979 58.5997L57.25 65.1957L70.2979 71.9977L83.3457 65.1957Z",
    fill: "#FFCDB8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4672 66.1689L70.3039 60.5255L59.1406 66.1689L70.3039 71.9925L81.4672 66.1689Z",
    fill: "url(#paint0_linear_47558_11782)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3039 95.4106L52.7969 85.3286V65.1544L70.3039 74.2889V95.4106Z",
    fill: "#F16E4A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3047 95.5053L87.8117 85.4233V65.2491L70.3047 74.3836V95.5053Z",
    fill: "#814F42"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0938 92.3266L86.0273 84.2991V68.2442L72.0938 75.5096V92.3266Z",
    fill: "#FFC5AF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0938 90.0923L84.1736 83.1307V69.2178L72.0938 75.5152V90.0923Z",
    fill: "url(#paint1_linear_47558_11782)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2979 60.5254V58.5997L57.25 65.1957L59.1346 66.1689L70.2979 60.5254Z",
    fill: "#6A4035"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7994 78.9536C63.1753 79.762 63.0774 81.1008 62.3668 81.4715C61.9834 81.6944 61.5568 81.833 61.1156 81.8783C60.4874 81.7856 60.0858 81.1626 59.7202 80.4778C59.3546 79.7929 59.2053 78.3615 59.7923 78.0268C60.0666 77.878 60.3568 77.7606 60.6573 77.6766C61.2855 77.4964 62.336 77.965 62.7994 78.9536Z",
    fill: "#534B48"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4215 81.8585C62.2938 81.4283 62.592 80.2505 62.0877 79.2278C61.5833 78.205 60.4673 77.7246 59.595 78.1548C58.7228 78.5849 58.4245 79.7628 58.9289 80.7855C59.4332 81.8083 60.5492 82.2886 61.4215 81.8585Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M137.741 24.0699L120.234 15.2237L102.727 24.0699L120.234 33.1993L137.741 24.0699Z",
    fill: "#FF8D6D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M133.275 24.1056L120.228 17.5147L107.18 24.1056L120.228 30.9127L133.275 24.1056Z",
    fill: "#FFCDB8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M131.389 25.0797L120.226 19.4415L109.062 25.0797L120.226 30.9034L131.389 25.0797Z",
    fill: "url(#paint2_linear_47558_11782)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M120.234 54.3256L102.727 44.2385V24.0694L120.234 33.1988V54.3256Z",
    fill: "#F16E4A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M120.234 54.4203L137.741 44.3332V24.1641L120.234 33.2935V54.4203Z",
    fill: "#814F42"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M122.016 51.2365L135.949 43.209V27.1592L122.016 34.4246V51.2365Z",
    fill: "#FFC5AF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M122.016 49.0013L134.095 42.0448V28.1319L122.016 34.4293V49.0013Z",
    fill: "url(#paint3_linear_47558_11782)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M120.228 19.4405V17.5147L107.18 24.1056L109.064 25.0788L120.228 19.4405Z",
    fill: "#6A4035"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M112.723 37.8649C113.099 38.6784 113.001 40.0172 112.291 40.3828C111.908 40.6122 111.479 40.7545 111.034 40.7999C110.406 40.7123 109.974 40.0893 109.639 39.4045C109.304 38.7196 109.124 37.283 109.711 36.9535C109.985 36.8047 110.275 36.6873 110.576 36.6033C111.209 36.4077 112.26 36.8762 112.723 37.8649Z",
    fill: "#534B48"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M111.359 40.7755C112.231 40.3454 112.53 39.1675 112.025 38.1448C111.521 37.122 110.405 36.6416 109.533 37.0718C108.66 37.5019 108.362 38.6798 108.866 39.7025C109.371 40.7253 110.487 41.2057 111.359 40.7755Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M157.35 40.5419C157.555 40.5419 157.752 40.4605 157.897 40.3156C158.041 40.1708 158.123 39.9743 158.123 39.7695C158.123 39.5647 158.041 39.3682 157.897 39.2233C157.752 39.0785 157.555 38.9971 157.35 38.9971C157.146 38.9971 156.949 39.0785 156.804 39.2233C156.659 39.3682 156.578 39.5647 156.578 39.7695C156.578 39.9743 156.659 40.1708 156.804 40.3156C156.949 40.4605 157.146 40.5419 157.35 40.5419Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M110.446 38.8839L98.382 46.6848V68.5479L86.9922 75.5919",
    stroke: "#FFCDB8",
    strokeWidth: 1.85,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3828 68.5469L143.329 95.4099",
    stroke: "#FFCDB8",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "1 3"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M162.34 87.1153L76.9062 136.289V65.9731L162.34 20.4034V87.1153Z",
    fill: "url(#paint4_linear_47558_11782)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M140.069 83.8876C140.069 83.8876 135.301 75.0723 143.333 74.3772C151.366 73.6821 184.82 71.262 184.82 71.262C184.82 71.262 188.362 70.8604 188.393 74.9179C188.424 78.9754 188.615 108.825 188.615 108.825C188.615 108.825 189.284 113.598 183.754 113.284C178.224 112.97 148.179 108.058 148.179 108.058C148.179 108.058 142.118 107.713 142.118 103.459C142.118 99.2063 140.069 83.8876 140.069 83.8876Z",
    fill: "#F16E4A"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M144.348 84.85C144.348 84.85 135.816 76.5033 143.833 75.803C151.85 75.1027 185.319 72.7135 185.319 72.7135C185.319 72.7135 188.862 72.3067 188.893 76.3694C188.924 80.432 189.114 110.276 189.114 110.276C189.114 110.276 189.784 115.05 184.253 114.735C178.723 114.421 148.678 109.504 148.678 109.504C148.678 109.504 142.618 109.159 142.618 104.906C142.618 100.653 144.348 84.85 144.348 84.85Z",
    fill: "#74493E"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M176.106 69.5205C176.106 75.8076 170.715 80.9052 164.067 80.9052C157.42 80.9052 152.023 75.8076 152.023 69.5205C152.023 63.9955 156.869 58.8876 162.62 58.1307C163.427 58.0688 164.237 58.0516 165.046 58.0792C171.698 58.0792 176.106 63.2335 176.106 69.5205Z",
    fill: "#AE6D1B"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M162.338 80.9062C168.625 80.9062 173.723 75.8091 173.723 69.5215C173.723 63.2339 168.625 58.1368 162.338 58.1368C156.05 58.1368 150.953 63.2339 150.953 69.5215C150.953 75.8091 156.05 80.9062 162.338 80.9062Z",
    fill: "url(#paint5_linear_47558_11782)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M162.339 77.3684C166.673 77.3684 170.187 73.8551 170.187 69.5211C170.187 65.1872 166.673 61.6739 162.339 61.6739C158.006 61.6739 154.492 65.1872 154.492 69.5211C154.492 73.8551 158.006 77.3684 162.339 77.3684Z",
    fill: "url(#paint6_linear_47558_11782)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M166.748 72.0646V66.9773L162.34 64.4337L157.938 66.9773V72.0646L162.34 74.6083L166.748 72.0646Z",
    fill: "#FFDA88"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M137.613 81.879C137.613 81.879 136.583 75.386 144.647 75.8391C152.71 76.2922 188.249 78.8462 188.249 78.8462C188.249 78.8462 192.307 78.6402 192.343 82.6978C192.379 86.7553 192.554 116.424 192.554 116.424C192.554 116.424 193.229 121.198 187.693 120.889C182.158 120.58 140.929 117.449 140.929 117.449C140.929 117.449 137.628 117.31 137.628 113.057C137.628 108.804 137.613 81.879 137.613 81.879Z",
    fill: "#74493E"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M135.722 83.0883C135.722 83.0883 134.692 76.5901 142.761 77.0432C150.83 77.4963 186.359 80.0554 186.359 80.0554C186.359 80.0554 190.416 79.8443 190.478 83.907C190.54 87.9696 190.694 117.634 190.694 117.634C190.694 117.634 191.364 122.407 185.828 122.093C180.293 121.779 139.085 118.669 139.085 118.669C139.085 118.669 135.784 118.53 135.779 114.276C135.774 110.023 135.722 83.0883 135.722 83.0883Z",
    fill: "#F16E4A"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M178.312 97.5377C178.312 97.5377 177.998 95.3956 180.716 95.5295C183.435 95.6634 195.79 96.414 195.79 96.414C195.79 96.414 197.49 96.4603 197.5 98.6641C197.51 100.868 197.5 105.26 197.5 105.26C197.5 105.26 197.624 107.248 195.131 107.104C192.639 106.959 180.335 106.353 180.335 106.353C180.335 106.353 178.234 106.384 178.234 104.499C178.234 102.615 178.312 97.5377 178.312 97.5377Z",
    fill: "#74493E"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M176.5 98.1639C176.5 98.1639 177.251 96.3213 179.461 96.4305C182.175 96.5644 194.296 97.4135 194.296 97.4135C194.296 97.4135 195.99 97.4598 196 99.6636C196.01 101.867 196 106.26 196 106.26C196 106.26 196.129 108.247 193.637 108.103C191.144 107.959 179.08 107.254 179.08 107.254C179.08 107.254 177.443 107.049 176.5 105.164C176 104.164 175.484 103.053 175.5 101.664C175.52 99.9707 176.5 98.1639 176.5 98.1639Z",
    fill: "#FFAF65"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M183.209 104.814C184.571 104.814 185.675 103.71 185.675 102.347C185.675 100.985 184.571 99.8809 183.209 99.8809C181.846 99.8809 180.742 100.985 180.742 102.347C180.742 103.71 181.846 104.814 183.209 104.814Z",
    fill: "#6A4035"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M182.373 105.066C183.735 105.066 184.839 103.961 184.839 102.599C184.839 101.237 183.735 100.133 182.373 100.133C181.011 100.133 179.906 101.237 179.906 102.599C179.906 103.961 181.011 105.066 182.373 105.066Z",
    fill: "#FFECC7"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M166.5 67.1641L158.219 72.0355",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M166 66.6641L158 71.1641V69.6641L164.5 65.6641L166 66.6641Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M136 86.6641L167 89.1641",
    stroke: "#74493E",
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M159.5 112.164L190.5 114.664",
    stroke: "#74493E",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 169,
    cy: 89.6641,
    r: 2,
    fill: "#FFAF65",
    stroke: "#74493E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 157,
    cy: 111.664,
    r: 2,
    fill: "#FFAF65",
    stroke: "#74493E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 104.5,
    y: 101.164,
    width: 16,
    height: 30,
    rx: 8,
    fill: "url(#paint7_linear_47558_11782)",
    fillOpacity: 0.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 101.664,
    width: 15,
    height: 29,
    rx: 7.5,
    stroke: "#F16E4A",
    strokeOpacity: 0.5
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M110.39 110.689C110.3 110.516 110.175 110.386 110.015 110.299C109.855 110.209 109.67 110.164 109.46 110.164C109.23 110.164 109.025 110.216 108.845 110.319C108.665 110.422 108.523 110.569 108.42 110.759C108.32 110.949 108.27 111.169 108.27 111.419C108.27 111.669 108.32 111.891 108.42 112.084C108.523 112.274 108.665 112.421 108.845 112.524C109.025 112.627 109.23 112.679 109.46 112.679C109.77 112.679 110.022 112.592 110.215 112.419C110.408 112.246 110.527 112.011 110.57 111.714H109.265V111.259H111.18V111.704C111.143 111.974 111.047 112.222 110.89 112.449C110.737 112.676 110.535 112.857 110.285 112.994C110.038 113.127 109.763 113.194 109.46 113.194C109.133 113.194 108.835 113.119 108.565 112.969C108.295 112.816 108.08 112.604 107.92 112.334C107.763 112.064 107.685 111.759 107.685 111.419C107.685 111.079 107.763 110.774 107.92 110.504C108.08 110.234 108.295 110.024 108.565 109.874C108.838 109.721 109.137 109.644 109.46 109.644C109.83 109.644 110.158 109.736 110.445 109.919C110.735 110.099 110.945 110.356 111.075 110.689H110.39ZM113.837 112.454H112.382L112.132 113.164H111.537L112.782 109.684H113.442L114.687 113.164H114.087L113.837 112.454ZM113.677 111.989L113.112 110.374L112.542 111.989H113.677ZM116.374 113.199C116.14 113.199 115.93 113.159 115.744 113.079C115.557 112.996 115.41 112.879 115.304 112.729C115.197 112.579 115.144 112.404 115.144 112.204H115.754C115.767 112.354 115.825 112.477 115.929 112.574C116.035 112.671 116.184 112.719 116.374 112.719C116.57 112.719 116.724 112.672 116.834 112.579C116.944 112.482 116.999 112.359 116.999 112.209C116.999 112.092 116.964 111.997 116.894 111.924C116.827 111.851 116.742 111.794 116.639 111.754C116.539 111.714 116.399 111.671 116.219 111.624C115.992 111.564 115.807 111.504 115.664 111.444C115.524 111.381 115.404 111.284 115.304 111.154C115.204 111.024 115.154 110.851 115.154 110.634C115.154 110.434 115.204 110.259 115.304 110.109C115.404 109.959 115.544 109.844 115.724 109.764C115.904 109.684 116.112 109.644 116.349 109.644C116.685 109.644 116.96 109.729 117.174 109.899C117.39 110.066 117.51 110.296 117.534 110.589H116.904C116.894 110.462 116.834 110.354 116.724 110.264C116.614 110.174 116.469 110.129 116.289 110.129C116.125 110.129 115.992 110.171 115.889 110.254C115.785 110.337 115.734 110.457 115.734 110.614C115.734 110.721 115.765 110.809 115.829 110.879C115.895 110.946 115.979 110.999 116.079 111.039C116.179 111.079 116.315 111.122 116.489 111.169C116.719 111.232 116.905 111.296 117.049 111.359C117.195 111.422 117.319 111.521 117.419 111.654C117.522 111.784 117.574 111.959 117.574 112.179C117.574 112.356 117.525 112.522 117.429 112.679C117.335 112.836 117.197 112.962 117.014 113.059C116.834 113.152 116.62 113.199 116.374 113.199Z",
    fill: "#64CF6F"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M112.854 125.518C112.658 125.713 112.342 125.713 112.146 125.518L108.964 122.336C108.769 122.14 108.769 121.824 108.964 121.629C109.16 121.433 109.476 121.433 109.672 121.629L112.5 124.457L115.328 121.629C115.524 121.433 115.84 121.433 116.036 121.629C116.231 121.824 116.231 122.14 116.036 122.336L112.854 125.518ZM112 118.164C112 117.888 112.224 117.664 112.5 117.664C112.776 117.664 113 117.888 113 118.164H112ZM112 125.164V118.164H113V125.164H112Z",
    fill: "#64CF6F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_47558_11782",
    x1: 80.5781,
    y1: 66.2507,
    x2: 59.0781,
    y2: 66.7505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0A3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.911458,
    stopColor: "#954E49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_47558_11782",
    x1: 84,
    y1: 83.1641,
    x2: 72.593,
    y2: 74.8504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0A3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.911458,
    stopColor: "#954E49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_47558_11782",
    x1: 130.5,
    y1: 25.1641,
    x2: 109,
    y2: 25.6641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0A3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.911458,
    stopColor: "#954E49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_47558_11782",
    x1: 133.922,
    y1: 42.0747,
    x2: 122.517,
    y2: 33.7604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0A3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.911458,
    stopColor: "#954E49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_47558_11782",
    x1: 104.5,
    y1: 41.6641,
    x2: 138,
    y2: 101.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79AFFF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C4D96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_47558_11782",
    x1: 169.5,
    y1: 78.6641,
    x2: 156,
    y2: 60.1641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00800717,
    stopColor: "#EA922C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927083,
    stopColor: "#FFDB7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAC886"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_47558_11782",
    x1: 158.5,
    y1: 62.6641,
    x2: 167,
    y2: 76.1641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00800717,
    stopColor: "#E1943A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4D18B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_47558_11782",
    x1: 112.5,
    y1: 101.164,
    x2: 120.3,
    y2: 128.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A95F4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFA0FA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountL2Tip);
export default __webpack_public_path__ + "static/media/account-l2-tip.2375fa254d9c558e36cfcdfc1ab1189f.svg";
export { ForwardRef as ReactComponent };